/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { get, post, del } from './base';

const URL = '/space';

export const GetAllBranchesAPI = () => get(`${URL}/branches/`);
export const GetBranchesAPI = region =>
  get(`${URL}/branches/?region=${region}`);
export const GetRegionsAPI = () => get(`${URL}/regions/`);

export const GetMyFavoriteBranchesAPI = (query, config) =>
  query
    ? get(
        `${URL}/my-favorite-branches/?lat=${query.lat}&lon=${query.lng}`,
        config,
      )
    : get(`${URL}/my-favorite-branches/`, config);

export const GetNearMePublicSpaces = (query, count, config) =>
  query
    ? get(
        `${URL}/near-me/public-spaces/?lat=${query.lat}&lon=${query.lng}&count=${count}`,
        config,
      )
    : get(`${URL}/near-me/public-spaces/?count=${count}`, config);
export const GetNearMeMeetingRooms = (query, count, config) =>
  query
    ? get(
        `${URL}/near-me/meeting-rooms/?lat=${query.lat}&lon=${query.lng}&count=${count}`,
        config,
      )
    : get(`${URL}/near-me/meeting-rooms/?count=${count}`, config);
export const GetNearMeRetails = (query, count, config) =>
  query
    ? get(
        `${URL}/near-me/retails/?lat=${query.lat}&lon=${query.lng}&count=${count}`,
        config,
      )
    : get(`${URL}/near-me/retails/?count=${count}`, config);

export const GetFavoriteBranchesAPI = config =>
  get(`${URL}/favorite-branches/`, config);
export const PostFavoriteBranchesAPI = (branches, config) =>
  post(`${URL}/favorite-branches/`, branches, config);

export const GetBranchAPI = id => get(`${URL}/branches/${id}/`);

export const GetSpaceOfficeAPI = () => get(`${URL}/offices/`);

export const GetAllRetailsAPI = () => get(`${URL}/retails/?page_size=50`);
export const GetRetailAPI = id => get(`${URL}/retails/${id}/`);

export const GetMeetingRoom = id => get(`${URL}/meeting-rooms/${id}/`);
export const GetMeetingRooms = (id, config) =>
  get(`${URL}/meeting-rooms/?floor__branch=${id}`, config);
export const GetMeetingRoomReservations = (id, config) =>
  get(
    `${URL}/meeting-room/reservations/?meeting_room=${id}&page_size=1000`,
    config,
  );
export const PostMeetingRoomReservations = (data, config) =>
  post(`${URL}/meeting-room/reservations/`, data, config);
export const GetMeetingRoomReservation = (id, config) =>
  get(`${URL}/meeting-room/reservations/${id}/`, config);
export const DeleteMeetingRoomReservation = (id, config) =>
  del(`${URL}/meeting-room/reservations/${id}/`, config);
export const GetMypageMeetingRoomReservations = config =>
  get(`${URL}/mypage/meeting-room-reservations/`, config);

export const GetRemainingHour = config =>
  get(`${URL}/meeting-room/remaining-hour/`, config);
